import axios from "@/utils/request";
// 查询已购裸聊列表
export function queryMyNudeChat(data) {
    return axios.get(`/nude/chat/buy/record`, {params: data});
}